<script setup lang="ts">

import { AppMultiSelect } from '@shared/ui/selects'
import { ModalDefault } from '@shared/ui/modals'
import { AppInput } from '@shared/ui/inputs'
import { BtnPrimary, BtnSecondary } from '@shared/ui/buttons'

import { useCreateTeam } from '../../../model/teams/create-team.hook'

defineOptions({
  name: 'ModalCreateTeam',
})

const {
  isOpen,
  refName,
  refMembers,
  memberOptions,
  isSaving,
  isSaveDisabled,
  save,
  cancel,
} = useCreateTeam()
</script>

<template>
  <ModalDefault
    :show="isOpen"
    :loading="isSaving"
    title="Create team"
    is-close-button
    @click:overlay="cancel"
    @click:close="cancel"
  >
    <div class="modal-create-team">
      <AppInput
        v-model="refName"
        label="Team name"
        placeholder="Enter team name"
      />

      <AppMultiSelect
        v-model="refMembers"
        :options="memberOptions"
        label="Members"
        placeholder="Select members"
        clearable
      />
    </div>

    <template #controls>
      <BtnPrimary
        text="Save"
        color="emerald"
        :disabled="isSaveDisabled || isSaving"
        @click="save"
      />
      <BtnSecondary
        text="Cancel"
        @click="cancel"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalCreateTeam.scss" />
